import { ContactMethod } from '@lmc/ts-common'
import { FormCard, FormItem, FormRadio, FormRadioGroup } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import type { FormInstance } from 'antd'
import { NAMESPACE } from 'locale'
import { serviceUserProfileConstants as supConstants } from 'locale/serviceUserProfile'
import { useTranslation } from 'react-i18next'

type PreferredContactProps = { form: FormInstance }

export const PreferredContactFormCard = ({ form }: PreferredContactProps) => {
  const { t } = useTranslation(NAMESPACE.SERVICE_USER_PROFILE)

  const contactMethods = [
    ContactMethod.noPreference,
    ContactMethod.email,
    ContactMethod.phone,
    ContactMethod.fax,
    ContactMethod.sms,
    ContactMethod.url
  ]

  return (
    <FormCard>
      <FormItem
        label={<Text>{t(supConstants.PREFERRED_CONTACT_METHOD)}</Text>}
        name="preferredContactMethod"
        // rules={[
        //   {
        //     required: true,
        //     message: 'Please select a contact method!',
        //   },
        // ]}
      >
        <FormRadioGroup value={form.getFieldValue('preferredContactMethod')}>
          {contactMethods.map((method) => (
            <FormRadio value={method} text={t(supConstants[method])} />
          ))}
        </FormRadioGroup>
      </FormItem>
    </FormCard>
  )
}
